// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2wXeM","inputDescription":"styles_inputDescription__3wSKr"};